var _path;

import * as React from "react";

function SvgExclamationLightCircle(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 2C10.058 2 2 10.058 2 20s8.058 18 18 18 18-8.058 18-18S29.942 2 20 2zm0 33.75c-8.684 0-15.75-7.066-15.75-15.75 0-8.684 7.066-15.75 15.75-15.75 8.684 0 15.75 7.066 15.75 15.75 0 8.684-7.066 15.75-15.75 15.75zm0-12.375c.622 0 1.125-.503 1.125-1.125V11a1.124 1.124 0 10-2.25 0v11.25c0 .619.506 1.125 1.125 1.125zm0 2.813a1.688 1.688 0 10.001 3.375A1.688 1.688 0 0020 26.188z"
  })));
}

export default SvgExclamationLightCircle;